import { getCurrentVisit } from '../../models/visitor';
import { getVisitActivities, getVisitorActivities } from './activities';
import { SitecoreCookieNames } from './tracker';
import { UniformCookieNames } from '../../trackers/tracker';
import { getNullLogger } from '@uniformdev/common';
export var defaultGetCookieName = function defaultGetCookieName(type) {
  switch (type) {
    case "campaign":
      return SitecoreCookieNames.Campaign;
    case "campaigns":
      return SitecoreCookieNames.Campaigns;
    case "goals":
      return SitecoreCookieNames.Goals;
    case "patterns":
      return SitecoreCookieNames.PatternMatches;
    case "profiles":
      return SitecoreCookieNames.ProfileScores;
    case "visitCount":
      return UniformCookieNames.VisitCount;
  }
  return;
};
export var defaultGetCookieValueFromVisit = function defaultGetCookieValueFromVisit(type, visitor, logger, loggerPrefix) {
  if (!logger) logger = getNullLogger();
  //
  //Get value from latest visit.
  var visit = getCurrentVisit(visitor);
  if (!visit) {
    return;
  }
  switch (type) {
    case "campaign":
      return getValueForCampaignCookie([visit], logger, loggerPrefix);
    case "campaigns":
      var campaigns = getVisitActivities('campaign', visit, logger, loggerPrefix);
      return getValueForActivitiesCookie(campaigns);
    case "goals":
      var goals = getVisitActivities('goal', visit, logger, loggerPrefix);
      return getValueForActivitiesCookie(goals);
    case "patterns":
      return getValueForPatternsCookie(visit);
    case "profiles":
      return getValueForProfilesCookie(visit);
  }
  return {
    unsupportedCookieType: true
  };
};
export var defaultGetCookieValueFromVisitor = function defaultGetCookieValueFromVisitor(type, visitor, logger, loggerPrefix) {
  var _a, _b;
  if (!logger) logger = getNullLogger();
  //
  //Get value for visitor cookie.
  switch (type) {
    case "campaign":
      return getValueForCampaignCookie(visitor.visits, logger, loggerPrefix);
    case "campaigns":
      var campaigns = getVisitorActivities('campaign', visitor, logger, loggerPrefix);
      return getValueForActivitiesCookie(campaigns);
    case "goals":
      var goals = getVisitorActivities('goal', visitor, logger, loggerPrefix);
      return getValueForActivitiesCookie(goals);
    case "patterns":
      return getValueForPatternsCookie(visitor);
    case "profiles":
      return getValueForProfilesCookie(visitor);
    case "visitCount":
      return {
        value: (_b = (_a = visitor.visits) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0
      };
  }
  return undefined;
};
function getValueForCookie(data, getValue) {
  if (data) {
    var values_1 = [];
    Object.keys(data).forEach(function (key) {
      var value = getValue(data[key]);
      if (value) {
        values_1.push("".concat(key, "=").concat(value));
      }
    });
    return values_1.join(",");
  }
  return undefined;
}
function getValueForCampaignCookie(visits, logger, loggerPrefix) {
  var campaigns = [];
  visits.forEach(function (visit) {
    var _a, _b;
    var campaign = visit.data.campaign;
    if (!campaign) return;
    var id = (_b = (_a = visit.data.campaign) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id;
    if (!id) {
      logger.debug("".concat(loggerPrefix, " - Campaign was found on the visit but no id is set, so unable to include this campaign in the cookie value."), {
        campaign: campaign,
        visit: visit.id,
        visitor: visit.visitorId
      });
      return;
    }
    if (!campaigns.includes(id)) {
      campaigns.push(id);
    }
  });
  return {
    value: campaigns.join(',')
  };
}
function getValueForActivitiesCookie(activities) {
  var value = getValueForCookie(activities, function (dates) {
    return dates.map(function (date) {
      return date.getTime();
    }).join("|");
  });
  return {
    value: value
  };
}
function getValueForPatternsCookie(source) {
  var _a;
  var value = getValueForCookie((_a = source.data.patterns) === null || _a === void 0 ? void 0 : _a.data, function (p) {
    return p.patternId;
  });
  return {
    value: value
  };
}
function getValueForProfilesCookie(source) {
  var _a;
  var value = getValueForCookie((_a = source.data.profiles) === null || _a === void 0 ? void 0 : _a.data, function (p) {
    if (p.keys) {
      var values = [];
      Object.keys(p.keys).forEach(function (key) {
        var _a, _b;
        var value = (_b = (_a = p.keys[key]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0;
        if (value > 0) {
          values.push("".concat(key, "_").concat(value));
        }
      });
      if (values.length > 0) {
        return values.join("|");
      }
    }
    return undefined;
  });
  return {
    value: value
  };
}